var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-content",
    class: {
      'section-content--focus': _vm.$root.listFocus.length > 1
    }
  }, [(_vm.currentFragment) ? _c('fragment', {
    attrs: {
      "fragment": _vm.currentFragment
    }
  }) : _c('div', [_vm._v("\n    loading...\n  ")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62c52549","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Edit.vue
// module id = 96
// module chunks = 1